import React from "react";
import Image from "next/image";
import "./ThankYouPopup.styles.scss";

const ThankYouPopup = () => {
  return (
    <div className="thankyouMainContainer">
      <div className="thankyouIconContainer">
        <Image
          src="https://assets.turnoclub.com/developer/innovolt/icons/thankyou-message.svg"
          width={50}
          height={50}
          alt="thank you icon"
        />
        <h2 className="thankyouTitle">Thank you</h2>
      </div>
      <div className="thankyouDescription">
        Your Number have been received, our team will call you back in 24 hours
      </div>
    </div>
  );
};

export default ThankYouPopup;
